import React, { useState, useEffect } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import { loginFlagSelector } from 'redux/auth/selectors';
import { useDispatch, useSelector } from 'react-redux';
import config from 'coeus.config';
import JSROverlay from './JSROverlay';
import { setLoginFlag } from 'redux/actions/authActions';

const OVERLAYS = {
    JSROverlay: JSROverlay,
};

const Overlay = ({ history }) => {
    const [open, setOpen] = useState(false);
    const loginFlag = useSelector(loginFlagSelector);
    const dispatch = useDispatch();

    const handleClose = () => {
        setOpen(false);
        dispatch(setLoginFlag(false));
    };

    useEffect(() => {
        if (loginFlag && config.post_login_overlay?.enabled) {
            setOpen(true);
        }
    }, [loginFlag]);

    const getOverlay = () => {
        if (open) {
            const Component = OVERLAYS[config.post_login_overlay.overlay];
            return <Component handleClose={handleClose} history={history} />;
        }
    };

    return (
        <Backdrop
            style={{ zIndex: 1000, backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
            open={open}
            onClick={handleClose}
        >
            {getOverlay()}
        </Backdrop>
    );
};

export default Overlay;
